'use strict';

import Inputmask from "inputmask";
import { FileUploaders } from '../../_modules/fileUploader/fileUploader';

export default class FormsHandler {
	constructor(form, callback, loader) {
		this.form = form;
		this.callback = callback;
		this.loader = loader;
		this.fieldErrorClass = "error";

		if (!this.form) return false;

		this.form.formHandlerObject = this;

		this.inputs = [...this.form.querySelectorAll('input')];

		this._initMasks();
		this.fileUploaders = new FileUploaders({ root: 'data-file' });
		this._initValidation();
		this._handler();
	}

	_initValidation() {
		let that = this;

		this.validationDefaults = {
			errorClass: that.fieldErrorClass,
			errorPlacement: function(error, element) {
				if (typeof element.attr("data-custom-select") !== "undefined") {
					error.insertAfter(element.siblings(":last"));
				} else {
					error.insertAfter(element);
				}
			},
			highlight: function(element, errorClass){
				if (typeof $(element).attr("data-custom-select") !== "undefined") {
					$(element).parent().addClass(errorClass);
				} else {
					$(element).addClass(errorClass);
				}
			},
			unhighlight: function(element, errorClass){
				if (typeof $(element).attr("data-custom-select") !== "undefined") {
					$(element).parent().removeClass(errorClass);
				} else {
					$(element).removeClass(errorClass);
				}
			},
		}
	}

	update() {
		this.inputs = [...this.form.querySelectorAll('input')];
		this._initMasks();
	}

	_initMasks() {
		this.inputs.forEach(input => {
			if (input.hasAttribute('data-mask-inited')) return false;

			let type = input.dataset.maskType || input.getAttribute('type');
			if (type === 'tel') {
				Inputmask({ "mask": arNextOptions['THEME']['PHONE_MASK'], 'showMaskOnHover': true }).mask(input);
				input.setAttribute('data-mask-inited', true);
			}
			if (type === 'telegram') {
				Inputmask({ regex: "@[A-Za-z0-9_]*", 'showMaskOnHover': true }).mask(input);
				input.setAttribute('data-mask-inited', true);
			}
			if (type === 'skype') {
				Inputmask({ mask: "live:*{*}", 'showMaskOnHover': true }).mask(input);
				input.setAttribute('data-mask-inited', true);
			}
		})
	}

	_validateFilesCount() {
		let isValid = true;
		this.fileUploaders.inputs.forEach(fileUploader => {
			isValid = fileUploader.isValid();
		});

		return isValid;
	}

	// _getFormData() {
	// 	let formData = new FormData(this.form);

	// 	this.fileUploaders.inputs.forEach(fileUploader => {
	// 		let inputEl = fileUploader.addButton,
	// 		 	filesList = inputEl.files;

	// 		for (let i = 0; i < filesList.length; i++) {
	// 		    formData.append(filesList[i].name, filesList[i])
	// 		}
	// 	});

	// 	return formData;
	// }

	_getFormData() {
		let formData = new FormData(this.form);

		this.fileUploaders.inputs.forEach(fileUploader => {
			let filesList = fileUploader.getFilesList();

			filesList.forEach(file => {
				formData.append(file.name, file);
			});
		});

		return formData;
	}

	_handler() {
		let that = this;

		if (this.form.dataset.request !== 'no-ajax') {
			const opts = $.extend({}, {
				submitHandler: function(form) {
					if (that._validateFilesCount()) {
						let formData = that._getFormData();
						$.ajax({
							url: form.action,
							data: formData,
							method: form.method,
							dataType: 'json',
							processData: false,
						    contentType : false,
							beforeSend: function() {
								if (that.loader) {
									that.loader.classList.add('is-loading');
								} else {
									document.body.classList.add('is-loading');
								}
							},
							success: (res) => {
								if (that.loader) {
									that.loader.classList.remove('is-loading');
								} else {
									document.body.classList.remove('is-loading');
								}

								let modalBody = document.querySelector('.modal [data-modal-body]'),
									successContainer = document.querySelector('.modal [data-success-body]');

								if (res.success || !res.status) {
									if (that.callback) that.callback(res);

									$(that.form).trigger("forms-handler-submit");

									if (modalBody && successContainer) {
										modalBody.style.display = 'none';
										successContainer.style.display = 'block';
									}
								} else {
									if (res.modalView) {
										let modal = $(res.modalView).appendTo('body').modal();
										modal.on($.modal.CLOSE, function(event, m) {
											m.elm.remove();
										});
									}
								}
							},
							error: (res) => {

							}
						});
					}
				}
			}, that.validationDefaults);
			this.validator = $(this.form).validate(opts);
		} else {
			this.validator = $(this.form).validate(that.validationDefaults);
		}
		// Настройки валидации из ASPRO в custom.js  initJqueryValidator()
	}

}
